import { createSlice } from '@reduxjs/toolkit';

const initialState = { title: '', show: false };
const headerSlice = createSlice({
    name: 'header',
    initialState,
    reducers: {
        setTitle: (state, action) => {
            if (action.payload) state = { title: action.payload, show: true }
            return state;
        },
        hideTitle: (state, action) => initialState,
        getTitle: (state, action) => {
            return state;
        },
    }
});

export const { setTitle, hideTitle, getTitle } = headerSlice.actions;

export default headerSlice.reducer;
